import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokonkandarshancab() {



    const cardData = {

keyword: "Pune to Konkan Darshan Cab",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable Pune to Konkan Darshan Cab services for families, pilgrims, and coastal travel lovers. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for a smooth journey through the Western Ghats to the Konkan region. Our service includes doorstep pickup from Pune, flexible one-way and round-trip options, 24/7 support, and transparent pricing, ensuring a peaceful and scenic travel experience across beaches, temples, and coastal villages of Konkan.",

topPlaces: [
    {
        title: "Ganpatipule Beach & Temple",
        description:
            "Ganpatipule is one of the most sacred and scenic destinations in Konkan, known for its clean white-sand beach and the famous Swayambhu Ganpati Temple located right on the shoreline. The combination of spiritual significance and natural coastal beauty makes it a top attraction for pilgrims and tourists. Visitors enjoy peaceful beach walks, sunset views, and devotional darshan, making it a complete spiritual and leisure experience on the Konkan coast."
    },
    {
        title: "Alibaug Beaches",
        description:
            "Alibaug is a popular coastal destination known for its clean beaches, historic forts, and relaxed seaside atmosphere. Beaches like Nagaon, Kashid, and Alibaug Beach offer water sports, photography spots, and peaceful coastal relaxation. The region is ideal for weekend trips, family outings, and short vacations from Pune, offering a refreshing break along the Arabian Sea coastline."
    },
    {
        title: "Ratnagiri Coastal Region",
        description:
            "Ratnagiri is a major coastal district in Konkan known for its beautiful beaches, Alphonso mango farms, seafood, and historical significance. The region offers attractions like Mandvi Beach, Ratnadurg Fort, and coastal viewpoints. It is a perfect destination for travelers seeking a mix of natural beauty, cultural heritage, and authentic Konkan lifestyle experiences."
    },
    {
        title: "Tarkarli Beach & Water Sports",
        description:
            "Tarkarli is famous for its crystal-clear waters, white sandy beaches, and adventure water sports like scuba diving and snorkeling. It is one of the cleanest and most beautiful beaches in Maharashtra, attracting adventure lovers and nature enthusiasts. The peaceful surroundings and vibrant marine life make it a must-visit coastal destination in Konkan."
    },
    {
        title: "Malvan Sindhudurg Fort",
        description:
            "Sindhudurg Fort is a historic sea fort built by Chhatrapati Shivaji Maharaj and located off the coast of Malvan. Accessible by boat, the fort stands strong in the Arabian Sea and offers panoramic ocean views along with deep historical importance. It is a key attraction for history lovers and coastal explorers visiting Konkan."
    },
    {
        title: "Dapoli & Karde Beach",
        description:
            "Dapoli is a peaceful coastal town in Konkan known for its long, clean beaches like Karde, Murud, and Ladghar. The region is less crowded, making it ideal for relaxation, dolphin spotting, and peaceful seaside stays. It is a perfect destination for travelers seeking calm and scenic coastal escapes from Pune."
    },
    {
        title: "Harihareshwar Temple & Beach",
        description:
            "Harihareshwar is a unique coastal pilgrimage destination known for its ancient Shiva temple and beautiful beach surrounded by hills. Devotees visit the temple for spiritual blessings while also enjoying the serene beach environment. The combination of religious importance and natural beauty makes it a popular stop in Konkan darshan tours."
    },
    {
        title: "Murud-Janjira Fort",
        description:
            "Murud-Janjira Fort is one of the strongest sea forts in India, located on an island off the Murud coastline. Known for its invincible architecture and historical legacy, the fort attracts history enthusiasts and tourists. The boat ride to the fort adds an adventurous element to the coastal journey in Konkan."
    },
    {
        title: "Chiplun & Vashishti River",
        description:
            "Chiplun is a scenic town in Konkan located on the banks of the Vashishti River, surrounded by lush green hills and waterfalls. It is known for its natural beauty, temples, and peaceful environment. The region is a common stopover for travelers exploring deeper Konkan routes from Pune."
    },
    {
        title: "Diveagar Beach",
        description:
            "Diveagar is a serene and less crowded beach destination in Konkan known for its clean shoreline, coconut groves, and peaceful atmosphere. It is ideal for relaxation, photography, and quiet coastal experiences. The nearby Suvarna Ganesh Temple adds spiritual significance to this beautiful coastal village."
    }
],



services: [
  {
    name: "Pune to Konkan Cab Service",
    description: "Rising Cab Service offers Pune to Konkan Cab Service for a smooth and scenic coastal journey across the beautiful Konkan belt. We provide well-maintained AC Sedan, SUV, Innova Crysta, and Tempo Traveller options with professional drivers, doorstep pickup, and 24x7 support. Ideal for families, groups, and travelers planning beach holidays, temple visits, and Konkan exploration."
  },
  {
    name: "Konkan Darshan Cab Pune",
    description: "Book Konkan Darshan Cab Pune with Rising Cab Service for a complete coastal sightseeing experience. Our experienced chauffeurs ensure safe driving, flexible halts at beaches and temples, and comfortable travel across Konkan destinations for families and tourists."
  },
  {
    name: "Pune Konkan Tour Cab",
    description: "Rising Cab Service provides Pune Konkan Tour Cab for well-planned coastal trips covering scenic beaches, villages, and temples. Enjoy clean vehicles, professional drivers, and customizable itineraries for a relaxing Konkan holiday experience."
  },
  {
    name: "Konkan Sightseeing Cab Pune",
    description: "Our Konkan Sightseeing Cab Pune service is designed for travelers who want to explore the beauty of the Konkan coast. We offer comfortable AC vehicles, experienced drivers, and flexible travel plans for a memorable sightseeing journey."
  },
  {
    name: "Pune to Konkan Taxi Service",
    description: "Book Pune to Konkan Taxi Service with Rising Cab Service for reliable and safe long-distance coastal travel. We ensure timely pickup, clean cars, and smooth highway driving for a stress-free journey."
  },
  {
    name: "Konkan Darshan Taxi Pune",
    description: "Rising Cab Service offers Konkan Darshan Taxi Pune for tourists and families planning coastal exploration. Enjoy comfortable rides, professional drivers, and flexible stops at popular Konkan destinations."
  },
  {
    name: "Pune Coastal Tour Cab Konkan",
    description: "Our Pune Coastal Tour Cab Konkan service provides scenic travel along beaches, ghats, and cultural spots. We ensure safe driving, comfortable seating, and customized travel plans for a perfect coastal holiday."
  },
  {
    name: "Konkan Trip Cab Pune",
    description: "Book Konkan Trip Cab Pune for complete coastal travel packages covering Ratnagiri, Tarkarli, Ganpatipule, and nearby destinations. We provide well-maintained vehicles and experienced chauffeurs for a smooth journey."
  },
  {
    name: "Pune Konkan Travel Cab",
    description: "Rising Cab Service offers Pune Konkan Travel Cab for flexible and comfortable long-distance coastal journeys. Ideal for families and groups seeking a relaxing travel experience with full convenience."
  },
  {
    name: "Best Konkan Darshan Cab Pune",
    description: "Our Best Konkan Darshan Cab Pune service ensures premium travel experience with safe drivers, clean vehicles, and customized sightseeing routes across Konkan’s top attractions."
  },
  {
    name: "Konkan SUV Cab Pune",
    description: "Book Konkan SUV Cab Pune for spacious and comfortable travel ideal for families and groups. Our SUVs are perfect for long coastal routes with extra comfort and safety."
  },
  {
    name: "Konkan Innova Cab Pune",
    description: "Rising Cab Service provides Konkan Innova Cab Pune for premium long-distance travel. Enjoy spacious seating, smooth rides, and luxury comfort for your Konkan journey."
  },
  {
    name: "Konkan Sedan Cab Pune",
    description: "Our Konkan Sedan Cab Pune service is perfect for budget-friendly coastal travel for small families and couples. We ensure clean AC sedans and safe driving for a comfortable journey."
  },
  {
    name: "Konkan Tour Booking Pune",
    description: "Book Konkan Tour Booking Pune with complete cab service, flexible itinerary, and customized travel plans. Ideal for beach holidays, temple visits, and scenic coastal exploration."
  },
  {
    name: "Konkan Holiday Cab Pune",
    description: "Rising Cab Service offers Konkan Holiday Cab Pune for relaxing coastal vacations with comfortable vehicles, experienced drivers, and well-planned travel routes."
  },

  {
    name: "Pune to Ratnagiri Taxi Service",
    description: "Book Pune to Ratnagiri Taxi Service with Rising Cab Service for a safe and scenic Konkan journey. We provide clean AC vehicles, professional drivers, and flexible travel options for families, tourists, and groups visiting Ratnagiri."
  },
  {
    name: "Pune to Ratnagiri Cab Service",
    description: "Rising Cab Service offers Pune to Ratnagiri Cab Service with reliable long-distance travel, doorstep pickup, and comfortable vehicles. Perfect for coastal trips, temple visits, and family holidays."
  },
  {
    name: "Pune to Ratnagiri One Way Cab",
    description: "Our Pune to Ratnagiri One Way Cab service is ideal for affordable drop-only travel to the Konkan coast. Enjoy budget pricing, safe driving, and comfortable AC vehicles."
  },
  {
    name: "Pune to Ratnagiri Round Trip Taxi",
    description: "Book Pune to Ratnagiri Round Trip Taxi for flexible return travel with waiting options. We ensure safe, comfortable, and convenient travel for family vacations and sightseeing trips."
  },
  {
    name: "Pune to Ratnagiri Innova Cab",
    description: "Rising Cab Service offers Pune to Ratnagiri Innova Cab for premium comfort and spacious seating. Ideal for long-distance coastal travel with families and groups."
  },
  {
    name: "Pune to Ratnagiri SUV Cab Service",
    description: "Our Pune to Ratnagiri SUV Cab Service is perfect for larger families needing extra comfort and space. Enjoy safe and smooth highway travel to Konkan destinations."
  },
  {
    name: "Pune to Ratnagiri Sedan Cab Service",
    description: "Book Pune to Ratnagiri Sedan Cab Service for budget-friendly and comfortable travel. Our clean AC sedans ensure safe and smooth coastal journeys."
  },
  {
    name: "Konkan Route Cab Pune Ratnagiri",
    description: "Rising Cab Service provides Konkan Route Cab Pune Ratnagiri for scenic coastal travel with experienced drivers, flexible stops, and comfortable vehicles."
  },

  {
    name: "Pune to Tarkarli Cab Service",
    description: "Book Pune to Tarkarli Cab Service with Rising Cab Service for a beautiful beach destination trip. We provide safe, comfortable, and reliable long-distance travel with AC vehicles and professional drivers."
  },
  {
    name: "Pune to Tarkarli Taxi Service",
    description: "Our Pune to Tarkarli Taxi Service ensures smooth coastal travel with well-maintained vehicles, experienced chauffeurs, and flexible pickup options for families and tourists."
  },
  {
    name: "Pune to Tarkarli Cab Booking",
    description: "Rising Cab Service offers instant Pune to Tarkarli Cab Booking with multiple vehicle options, transparent pricing, and 24x7 support for hassle-free travel planning."
  }
],

tableData: [
  ["Pune to Konkan Cab Service", "Konkan Darshan Cab Pune"],
  ["Pune Konkan Tour Cab", "Konkan Sightseeing Cab Pune"],
  ["Pune to Konkan Taxi Service", "Konkan Darshan Taxi Pune"],
  ["Pune Coastal Tour Cab Konkan", "Konkan Trip Cab Pune"],
  ["Pune Konkan Travel Cab", "Best Konkan Darshan Cab Pune"],
  ["Konkan SUV Cab Pune", "Konkan Innova Cab Pune"],
  ["Konkan Sedan Cab Pune", "Konkan Tour Booking Pune"],
  ["Konkan Holiday Cab Pune", "Pune to Ratnagiri Taxi Service"],
  ["Pune to Ratnagiri Cab Service", "Pune to Ratnagiri One Way Cab"],
  ["Pune to Ratnagiri Round Trip Taxi", "Pune to Ratnagiri Innova Cab"],
  ["Pune to Ratnagiri SUV Cab Service", "Pune to Ratnagiri Sedan Cab Service"],
  ["Konkan Route Cab Pune Ratnagiri", "Pune to Tarkarli Cab Service"]
],



whychoose: [
    {
        WhyChooseheading: "Complete Pune to Konkan Darshan Cab Service",
        WhyChoosedescription: "Rising Cab Service offers comfortable Pune to Konkan Darshan cab packages for families, tourists, pilgrims, nature lovers, and beach vacation travelers."
    },
    {
        WhyChooseheading: "Explore the Beauty of the Konkan Coast",
        WhyChoosedescription: "Travel through Maharashtra's scenic Konkan region and experience pristine beaches, temples, forts, waterfalls, coastal villages, and breathtaking sea views."
    },
    {
        WhyChooseheading: "Customized Konkan Tour Packages",
        WhyChoosedescription: "Choose from weekend tours, multi-day vacations, family holidays, temple tours, beach packages, and personalized Konkan travel itineraries."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Long-Distance Travel",
        WhyChoosedescription: "Our fleet includes Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles suitable for every travel requirement."
    },
    {
        WhyChooseheading: "Cover Major Konkan Tourist Destinations",
        WhyChoosedescription: "Travelers can visit Ganpatipule, Ratnagiri, Tarkarli, Malvan, Sindhudurg Fort, Devbagh Beach, Harihareshwar, Dapoli, Guhagar, and other famous attractions."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Doorstep pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby areas."
    },
    {
        WhyChooseheading: "Experienced Drivers for Konkan Routes",
        WhyChoosedescription: "Our professional drivers are familiar with coastal highways and ghat roads, ensuring safe and enjoyable travel throughout the journey."
    },
    {
        WhyChooseheading: "Perfect for Family Holidays and Group Tours",
        WhyChoosedescription: "Rising Cab Service caters to family vacations, honeymoon trips, corporate outings, religious tours, and group travel across the Konkan region."
    }
]
};

const faqData = [
    {
        question: "What is included in the Pune to Konkan Darshan Cab Package?",
        answer: "The package includes cab transportation and can be customized to cover popular Konkan destinations such as Ganpatipule, Ratnagiri, Tarkarli, Malvan, Sindhudurg, and other attractions."
    },
    {
        question: "Which tourist places can be covered during Konkan Darshan?",
        answer: "Popular destinations include Ganpatipule Temple, Ratnagiri, Tarkarli Beach, Sindhudurg Fort, Devbagh Beach, Harihareshwar, Dapoli, Guhagar, and Malvan."
    },
    {
        question: "Can I customize my Konkan tour itinerary?",
        answer: "Yes, travel plans can be fully customized based on preferred destinations, travel duration, sightseeing requirements, and accommodation plans."
    },
    {
        question: "Which vehicle is suitable for a Konkan family tour?",
        answer: "Ertiga and Innova Crysta are among the most preferred options because they provide excellent comfort and luggage space for long journeys."
    },
    {
        question: "Do you provide Tempo Travellers for group tours?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate tours, and sightseeing trips."
    },
    {
        question: "Can beach destinations and temple visits be combined in one package?",
        answer: "Yes, customers can combine beach tourism, temple darshan, sightseeing, and cultural attractions in a single Konkan tour package."
    },
    {
        question: "Are weekend Konkan tour packages available?",
        answer: "Yes, weekend and extended holiday packages are available depending on the destinations selected."
    },
    {
        question: "Can honeymoon couples book private cabs for Konkan travel?",
        answer: "Yes, private cab packages are popular among couples visiting scenic destinations like Tarkarli, Ganpatipule, and Malvan."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I book a Pune to Konkan Darshan Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Nitin Kamat",
        feedback:
            "Our Konkan tour covering Ganpatipule, Ratnagiri, and Tarkarli was exceptionally well organized. The vehicle was comfortable, and the entire coastal journey was truly memorable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Radhika Naik",
        feedback:
            "The customized Konkan Darshan package allowed us to explore beaches, temples, and local attractions at our own pace. The travel experience was smooth and enjoyable throughout.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Konkan Darshan Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-konkan-darshan-cab.jpg",
"description": "Book Pune to Konkan Darshan Cab Service with Rising Cab Service for a scenic coastal and beach tour across Konkan. Enjoy comfortable one-way and round-trip travel with AC sedans, SUVs, and Innova cars for family trips and holiday packages.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-konkan-darshan-cab"
}
};





    return (
        <div>

<Helmet>
  <title>Pune to Konkan Darshan Cab | Coastal Tour Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Konkan Darshan Cab Service for scenic coastal and beach travel. Get affordable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for Konkan tour packages."
/>

<meta
 name="keywords"
 content="pune to konkan cab, konkan darshan cab pune, pune konkan cab service, pune to konkan taxi, konkan tour cab pune, konkan travel cab pune, pune konkan trip cab, beach tour cab pune konkan, konkan darshan taxi pune, pune coastal tour cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/103.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetokonkandarshancab;